import type { connectEn } from "./connect-en.js";

export const connectKo: typeof connectEn = {
  eyebrow: "설정은 한 번이면 돼요",
  title: "쓰던 AI에 이 스킬을 더해 보세요",
  lead: "쓰고 있는 앱을 고르고, 세 단계만 따라 하면 끝나요.",
  choose: "어떤 AI를 쓰고 있나요?",
  pickHint: "앱을 고르면 연결 순서를 보여 드려요.",
  clientsLabel: "사용하는 AI 앱 선택",
  copyTitle: "연결 주소",
  copyHint: "먼저 복사해 두고, 앱이 서버 URL을 물으면 붙여 넣으세요.",
  copyButton: "주소 복사하기",
  describes: (repository: string) => `${repository}의 스킬과 문서.`,
  follow: (client: string) => `${client}에 연결하기`,
  guideHint: "앱을 열고 아래 순서대로 따라 하세요.",
  add: (client: string) => `${client}에 추가하기`,
  installTitle: (client: string) => `${client}에 한 번에 추가하기`,
  installHint: "앱이 열리면 이름과 주소가 채워져 있어요. 확인하고 진행하면 돼요.",
  open: (client: string) => `${client} 열기`,
  manual: "직접 설정하기",
  nameHint: (name: string) => `이름을 물으면 “${name}”을 쓰거나, 알아보기 쉬운 이름을 정하세요.`,
  help: "안내와 메뉴가 다른가요?",
  helpBody:
    "앱 버전이나 회사·팀 설정에 따라 메뉴가 다를 수 있어요. 공식 안내를 확인하거나, 관리자에게 외부 연결을 허용해 달라고 요청하세요.",
  official: "공식 연결 안내",
  shell: {
    title: "에이전트가 직접 설정하게 하기",
    lead: "MCP 서버 없이도 돼요. 명령을 실행할 수 있는 에이전트라면 skillcdn 명령으로 이 스킬을 읽을 수 있어요. 에이전트의 대화창에서 이렇게 말하세요:",
    message: (address: string) =>
      `이 프로젝트에서 npm install -g @skillcdn/cli 와 skillcdn use ${address} 를 실행하고, 출력되는 문장을 CLAUDE.md나 AGENTS.md에 넣어 줘.`,
    privateMessage: (address: string, origin: string) =>
      `이 프로젝트에서 npm install -g @skillcdn/cli, skillcdn use ${address}, skillcdn login --url ${origin} 을 차례로 실행해 줘. use가 출력하는 문장은 CLAUDE.md나 AGENTS.md에 넣고, login이 보여 주는 주소와 코드를 알려 줘.`,
    rest: "에이전트가 명령을 설치하고 이 프로젝트를 스킬에 연결해요. 그다음부터는 작업에 필요할 때마다 명령으로 스킬을 읽어요.",
    privateRest:
      "에이전트가 명령을 설치하고 이 프로젝트를 스킬에 연결해요. 비공개 저장소라서 주소와 코드를 보여 주는데, 로그인한 채로 그 주소를 열고 같은 코드인지 확인한 다음 승인하면 돼요.",
    copy: "이 메시지 복사하기",
    link: "가이드에서 자세히 보기",
  },
  private: {
    title: "비공개 저장소예요",
    body: "AI 앱이 이 저장소를 읽으려면 먼저 내 이름으로 로그인해야 해요. 브라우저에 SkillCDN 페이지가 열리면 GitHub로 로그인하고 앱을 허용하세요. GitHub에서 이 저장소를 볼 수 있는 사람만 들어올 수 있어요.",
    signIn: {
      chatgpt:
        "만들기를 누르면 ChatGPT가 로그인 페이지를 열어요. GitHub로 로그인하고 ChatGPT를 허용하세요.",
      claude:
        "커넥터를 추가하면 Claude가 로그인을 요청해요. GitHub로 로그인하고 Claude를 허용하세요.",
      cursor:
        "Cursor가 서버에 로그인하라고 알려 줘요. 브라우저에서 GitHub로 로그인하고 Cursor를 허용하세요.",
      vscode:
        "VS Code가 서버 인증을 요청해요. 허용한 다음 GitHub로 로그인하고 VS Code를 허용하세요.",
      claudeCode:
        "Claude Code에서 /mcp를 입력하고 서버를 골라 Authenticate를 선택하세요. GitHub로 로그인하고 Claude Code를 허용하세요.",
      codex:
        "추가 명령을 실행하면 Codex가 브라우저에 로그인 페이지를 열어요. GitHub로 로그인하고 Codex를 허용하세요. 페이지가 열리지 않았다면 아래 로그인 명령을 실행하세요.",
      gemini:
        "Gemini CLI에서 아래 인증 명령을 입력하세요. 브라우저에서 GitHub로 로그인하고 Gemini CLI를 허용하세요.",
      other:
        "앱이 인증 방식을 물으면 OAuth를 고르세요. 열리는 페이지에서 GitHub로 로그인하고 앱을 허용하세요.",
    },
    headless: "예약 작업이나 서버처럼 로그인할 수 없는 에이전트는 토큰을 써요.",
    headlessAction: "토큰 만들기",
    steps: {
      chatgpt:
        "이름을 적고, 설명에는 예시 화면의 문장을 넣으세요. 연결은 서버 URL로 둔 채 연결 주소를 붙여 넣고, 인증은 OAuth 그대로 둔 뒤 확인란에 체크하고 만들기를 누르세요.",
      other:
        "서버를 추가하고 연결 주소를 붙여 넣으세요. 연결 방식은 HTTP(Streamable HTTP)이고, 인증은 OAuth를 고르세요.",
    },
  },
  firstMessage: {
    label: "연결했다면, 첫 질문을 보내 보세요",
    text: (server: string) =>
      `${server} 서버에 어떤 스킬이 있는지 살펴봐 줘. 어떤 일을 도와줄 수 있는지 알려 주고, 무엇부터 해 볼지 같이 골라 줘.`,
    hint: "대화창에 붙여 넣어 보내세요. 서버에 다른 이름을 붙였다면 그 이름으로 바꿔 말하세요.",
    copy: "질문 복사하기",
  },
  preview: {
    copyHint: "눌러서 전체 복사",
    copySelected: "전체 선택했어요. 복사해서 사용하세요.",
    settings: "설정",
    general: "일반",
    account: "계정",
    name: "이름",
    url: "MCP 서버 URL",
    authentication: "인증",
    none: "없음",
    plugins: "플러그인",
    skills: "스킬",
    publicPlugins: "공개",
    personalPlugins: "개인용",
    createMcpApp: "MCP 앱 만들기",
    newPlugin: "새 플러그인",
    description: "설명",
    connection: "연결",
    serverUrl: "서버 URL",
    tunnel: "터널",
    oauth: "OAuth",
    noAuth: "인증 없음",
    oauthOrNone: "OAuth 또는 인증 없음",
    acknowledge: "이해했으며 계속 진행하겠습니다",
    create: "만들기",
    install: "설치",
    installServer: "서버 설치",
    work: "Work",
    customize: "사용자 지정",
    chatgptCustomize: "맞춤 설정",
    cursorCustomize: "Customize",
    projects: "프로젝트",
    connectors: "커넥터",
    addConnector: "커스텀 커넥터 추가",
    add: "추가",
    continue: "계속",
    tools: "도구",
    toolNames: "browse_repo · search_repo · load_skill · read_repo_file",
    enabled: "사용 중",
    newChat: "새 대화",
    ask: (server: string) => `${server} 서버에 어떤 스킬이 있어?`,
    terminal: "터미널",
    commandHint: "터미널에 명령을 붙여 넣고 Enter 키를 누르세요.",
    checkHint: "앱을 열고 서버가 연결되어 있는지 확인하세요.",
    example: "예시",
    http: "HTTP",
    remote: "원격 MCP 서버",
    mcp: "MCP",
    mcps: "MCPs",
    agent: "Agent",
    chatView: "채팅",
    addServer: "MCP: 서버 추가",
    trust: "신뢰",
  },
  clients: {
    chatgpt: {
      label: "ChatGPT",
      titles: ["플러그인을 여세요", "MCP 앱을 만드세요", "대화에서 써 보세요"],
      steps: [
        "왼쪽 메뉴에서 맞춤 설정 → 플러그인을 여세요(앱에서는 Customize → Plugins). 추가를 누른 다음 MCP 앱 만들기를 선택하세요.",
        "이름을 적고, 설명에는 예시 화면의 문장을 넣으세요. 연결은 서버 URL로 둔 채 연결 주소를 붙여 넣고, 인증에서 인증 없음을 고른 뒤 확인란에 체크하고 만들기를 누르세요.",
        "Work 대화를 열고 아래 첫 질문을 보내세요. 따로 지정하지 않아도 ChatGPT가 서버를 알아서 찾아 써요.",
      ],
      note: "ChatGPT 앱과 웹 모두 같은 화면이에요. 회사·팀 계정은 관리자가 먼저 커스텀 플러그인을 허용해야 할 수 있어요.",
    },
    claude: {
      label: "Claude",
      titles: ["커넥터를 추가하세요", "확인하고 진행하세요", "대화에서 써 보세요"],
      steps: [
        "‘Claude에 추가하기’를 누르세요. Claude의 사용자 지정 → 커넥터가 열리고 이름과 주소가 채워져 있어요. 버튼 없이 할 때는 거기서 추가 → 커스텀 커넥터 추가를 누르고 직접 붙여 넣으세요.",
        "이름과 MCP 서버 URL을 확인하고 계속을 누르세요.",
        "새 대화를 열고 아래 첫 질문을 보내세요. 필요한 순간에 Claude가 커넥터를 알아서 사용해요.",
      ],
      note: "왼쪽 아래 계정 메뉴의 설정 → 커넥터로 들어가도 같은 화면이 열려요. 회사·팀 계정은 소유자가 먼저 커넥터를 추가해야 할 수 있어요.",
    },
    cursor: {
      label: "Cursor",
      titles: ["설치 화면을 여세요", "서버를 확인하세요", "Agent 대화에서 물어보세요"],
      steps: [
        "‘Cursor에 추가하기’를 누르세요. 연결 정보가 채워진 화면이 열리면 확인하고 설치하세요.",
        "Customize → MCPs에서 새 서버가 켜져 있는지 확인하세요. 직접 설정하려면 아래 설정 코드를 .cursor/mcp.json에 넣으세요.",
        "Agent 대화창에서 아래 첫 질문을 보내세요. 도구 사용을 물어보면 허용하세요.",
      ],
      note: "이 컴퓨터에 Cursor가 설치되어 있어야 버튼이 동작해요.",
    },
    vscode: {
      label: "VS Code",
      titles: ["서버를 추가하세요", "서버를 신뢰하세요", "채팅에서 써 보세요"],
      steps: [
        "‘VS Code에 추가하기’를 누르고 앱에서 확인하세요. 명령 팔레트의 ‘MCP: 서버 추가’에서 HTTP를 골라 직접 추가할 수도 있어요.",
        "서버 설정을 저장하고, 신뢰 여부를 묻는 창에서 확인하세요. 직접 설정하려면 아래 설정 코드를 .vscode/mcp.json에 넣으세요.",
        "채팅 뷰를 열고 도구 구성에서 서버의 도구가 켜져 있는지 확인한 뒤, 아래 첫 질문을 보내세요.",
      ],
      note: "이 컴퓨터에 VS Code와 Copilot 채팅이 준비되어 있어야 해요.",
    },
    claudeCode: {
      label: "Claude Code",
      titles: ["서버를 추가하세요", "연결을 확인하세요", "스킬을 요청해 보세요"],
      steps: [
        "프로젝트 폴더에서 터미널을 열고 아래 명령을 실행하세요.",
        "claude로 Claude Code를 시작하고, /mcp를 입력해 연결을 확인하세요.",
        "아래 첫 질문을 보내세요. 에이전트가 폴더를 둘러보고 스킬을 찾아 지침을 불러와요.",
      ],
      note: "현재 프로젝트에 서버를 추가하는 명령이에요. Claude Code가 미리 설치되어 있어야 해요.",
    },
    codex: {
      label: "Codex CLI",
      titles: ["서버를 추가하세요", "연결을 확인하세요", "스킬을 요청해 보세요"],
      steps: [
        "터미널을 열고 아래 명령을 실행하세요.",
        "codex로 Codex를 시작하고, /mcp를 입력해 서버와 도구를 확인하세요.",
        "Codex에 아래 첫 질문을 보내고, 도움받고 싶은 일을 설명하세요.",
      ],
      note: "이 컴퓨터에 Codex CLI가 미리 설치되어 있어야 해요.",
    },
    gemini: {
      label: "Gemini CLI",
      titles: ["서버를 추가하세요", "연결을 확인하세요", "스킬을 요청해 보세요"],
      steps: [
        "터미널을 열고 아래 명령을 실행하세요.",
        "gemini로 Gemini CLI를 시작하고, /mcp list로 서버를 확인하세요.",
        "Gemini CLI에 아래 첫 질문을 보내세요. 평소 말하듯 물어도 괜찮아요.",
      ],
      note: "이 컴퓨터에 Gemini CLI가 미리 설치되어 있어야 해요.",
    },
    other: {
      label: "기타",
      titles: ["연결 설정을 찾으세요", "주소를 추가하세요", "대화를 시작하세요"],
      steps: [
        "앱에서 MCP 서버 또는 연동 설정을 찾으세요. HTTP로 원격 서버에 연결할 수 있는 앱이어야 해요.",
        "서버를 추가하고 연결 주소를 붙여 넣으세요. 연결 방식은 HTTP(Streamable HTTP)이고, 공개 저장소는 인증이 필요 없어요.",
        "서버의 도구를 켜고 아래 첫 질문을 보내세요. 잘 안 되면 앱의 MCP 연결 안내를 확인하세요.",
      ],
      note: "앱마다 설정 형식이 달라요. 해당 앱의 안내를 따라 주세요.",
    },
  },
};
